export enum ContactType {
    Phone = "ContactPointType.Phone",
    Fax = "ContactPointType.Fax",
    Email = "ContactPointType.Email",
    Pager = "ContactPointType.Pager",
    SMS = "ContactPointType.SMS",
    Website = "ContactPointType.URL"
}
